import { render, staticRenderFns } from "./CampaignPage2.vue?vue&type=template&id=3bf3952e&"
import script from "./CampaignPage2.vue?vue&type=script&lang=js&"
export * from "./CampaignPage2.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPage2.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports